// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerContainerStyles } from "@tps/Overrides/Widgets/Footer/FooterContainer";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";
import styled from "styled-components";

export const FooterTopSection = styled.div`
    background-color: ${color("text.main")};
`;

export const FooterBottomSection = styled.div`
    background-color: ${color("common.ui7")};
    ${({ isCheckoutPage }: any) => {
        if (isCheckoutPage) {
            return css`
                background-color: ${color("text.main")};
            `;
        }
    }}
`;

export const FooterContainerWrapper = styled.div``;

export const GeneralLinksWrapper = styled.div`
    &:not(:first-child) {
        min-width: 204px;
        ${xScreen("lte", "md")} {
            width: calc((100% / 3) - 14px);
        }
        ${xScreen("lte", 767)} {
            width: calc(50% - 12px);
            min-width: 152px;
        }
    }

    &:first-child {
        min-width: 430px;
        ${xScreen("lte", "md")} {
            width: calc((200% / 3) - 10px);
        }
        ${xScreen("lte", 767)} {
            min-width: unset;
            width: 100%;
        }
    }

    .social-links {
        margin-top: 12px;
        .link-wrapper {
            flex-basis: auto;
        }
    }
    .list-wrapper {
        padding: 0;
        text-transform: capitalize;
        .title-wrapper {
            margin-bottom: 12px;
        }
        .list-title {
            color: ${color("common.ui1")};
            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            padding-bottom: 8px;
            border-bottom: 1px solid ${color("common.ui4")};
            &:empty {
                display: none;
            }
        }

        .links-wrapper {
            margin-bottom: 8px;
            display: flex;
            padding-top: 0;
            &:last-child {
                margin-bottom: 0;
            }
            .list-link {
                > span {
                    font-size: 12px;
                    letter-spacing: 0;
                    line-height: 20px;
                    font-weight: normal;
                    color: ${color("common.ui2")};
                }
                &:hover > span {
                    color: ${color("common.ui8")};
                }
            }
        }
    }
`;

footerContainerStyles.topSectionInnerPage = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 22px;
        row-gap: 22px;
        background-color: ${color("text.main")};
        &&&& {
            padding-top: 24px;
            padding-bottom: 32px;
        }

        ${xScreen("lte", "md")} {
            column-gap: 20px;
            row-gap: 32px;
        }
        ${xScreen("lte", 767)} {
            column-gap: 24px;
        }
    `,
};
footerContainerStyles.bottomSectionInnerPage = {
    css: css`
        background-color: ${color("common.ui7")};
        &&&& {
            padding-top: 24px;
            padding-bottom: 24px;
        }
        ${({ isCheckoutPage }: any) => {
            if (isCheckoutPage) {
                return css`
                    background-color: ${color("text.main")};
                    &&&& {
                        padding: 16px;
                    }
                `;
            }
        }}
    `,
};
footerContainerStyles.companiesLinksWrapper = {
    css: css`
        margin-bottom: 24px;
        & > div {
            display: flex;
            column-gap: 20px;
            flex-wrap: wrap;
            & > div {
                display: flex;
                .link span {
                    line-height: 20px;
                    color: ${color("common.ui1")};
                    font-size: 12px;
                    font-weight: normal;
                }
            }
        }
    `,
};
footerContainerStyles.copyRightAndTermsWrapper = {
    css: css`
        display: flex;
        column-gap: 20px;
        ${xScreen("lte", 767)} {
            flex-direction: column;
            row-gap: 12px;
        }
        ${({ isCheckoutPage }: any) => {
            if (isCheckoutPage) {
                return css`
                    justify-content: space-between;
                `;
            }
        }}
    `,
};
footerContainerStyles.termsWrapper = {
    css: css`
        & > div {
            display: flex;
            column-gap: 20px;
            & > div {
                display: flex;
                .link span {
                    line-height: 20px;
                    color: ${color("common.ui2")};
                    font-size: 12px;
                    font-weight: normal;
                }
            }
            ${({ isCheckoutPage }: any) => {
                if (isCheckoutPage) {
                    return css`
                        column-gap: 36px;
                    `;
                }
            }}
        }
    `,
};
footerContainerStyles.copyRightWrapper = {
    css: css`
        font-size: 12px;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: normal;
        color: ${color("common.ui1")};
    `,
};
